export default __webpack_public_path__ + "static/media/Failure.836df994.mp3";